import { GetContentMarketplaceMeta, GetContentMarketplacePayload } from 'types/store/GetContentMarketplace';
import { createAsyncReducer } from 'utils/Redux';

import { getContentMarketplaceActions } from '../actions';

export default createAsyncReducer<GetContentMarketplaceMeta, GetContentMarketplacePayload>(getContentMarketplaceActions);
